import Grid from "@mui/material/Grid";
import React, {useEffect} from "react";
import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import TradeRow from "./TradeRow";
import {Button} from "@mui/material";
import {useFieldArray, useForm} from "react-hook-form";
import Typography from "@mui/material/Typography";
import moment from "moment";

const Item = styled(Paper)(({theme}) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.primary,
}));

const Portfolio = () => {
  let defaultTrade = {
    tradeId: "",
    buyTs: moment().format('YYYY-MM-DD HH:mm:ss'),
    buyPrice: "",
    buyQuantity: "",
    sellTs: "",
    sellPrice: "",
    sellQuantity: ""
  };
  const {register, handleSubmit, control, setValue, formState: {errors}} = useForm({
    defaultValues: {
      "trades": [defaultTrade]
    }
  })
  const {fields, insert, remove} = useFieldArray({
    control,
    name: "trades"
  })

  function getAllTrades() {
    fetch('/algo-trading/api/portfolios', {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      }
    }).then(function (response) {
      response.text().then(r => {
        if (response.ok) {
          const d = JSON.parse(r)
          if (d.trades.length !== 0) {
            setValue("trades", d.trades)
          }
        } else {
          console.log(r)
        }
      })
    })
  }

  useEffect(() => {
    getAllTrades();
  }, [])

  const removeTrade = (index, tradeId) => {
    if (tradeId === undefined || tradeId === "") {
      remove(index)
      return
    }

    fetch('/algo-trading/api/portfolios/' + tradeId, {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
      }
    }).then(function (response) {
      response.text().then(r => {
        if (response.ok) {
          getAllTrades()
        } else {
          console.log(r)
        }
      })
    })
  }

  const onSubmit = data => {
    // console.log(JSON.stringify(data))
    fetch('/algo-trading/api/portfolios', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      }
    }).then(function (response) {
      response.text().then(r => {
        console.log(r)
        getAllTrades();
      })
    }, function (error) {
      console.log(error.message)
    })
  }
  return (
    <>
      <Grid item xs={12}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {console.log(errors)}
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom component="div">
              Model Portfolio
            </Typography>
          </Grid>
          {fields.map((trade, index) => (
            <Grid item xs={12} key={trade.id}>
              <Item>
                <TradeRow register={register}
                          nameKey={`trades.${index}`}
                          index={index}
                          onAddTrade={() => insert(index + 1, defaultTrade)}
                          onDeleteTrade={() => removeTrade(index, trade?.tradeId)}
                          errors={errors}
                />
              </Item>
            </Grid>
          ))}
          <Grid item container xs={12} spacing={"2"}>
            <Grid item>
              <Button variant="contained" type="submit">Save</Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  )
}

export default Portfolio